module.exports = __webpack_public_path__ + "img/pic_03_nor.7beef2ab.png";